import React from 'react';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';

import Logo from '../../assets/images/autoboys-logo.png';
import Call from '../../assets/images/call-agent.png';
import Database from '../../Logic/Database';
import Claim from '../../Logic/Claim';
import './VerifyVehicleReg.css';

class VerifyVehicleReg extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      enteredReg: '',
      showHelp: false,
      vehicleReg: [],
      requiredLetters: [],
      isLoading: true,
      loadError: null,
    };
  }

  async componentDidMount() {
    // Alert if CustAppId is missing
    if (!this.props.CustAppId || this.props.CustAppId.length < 16) {
      await Swal.fire({
        title: 'Claim Reference Missing',
        text: 'Link expired. Kindly request your service consultant to resend you a link.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      this.setState({ isLoading: false });
      return;
    }

    // Fetch vehicle registration
    try {
      const vehicleReg = await Claim.FetchVehicleReg(this.props.CustAppId);

      if (!vehicleReg) {
        throw new Error('No vehicle registration found');
      }

      const vehicleRegArray = vehicleReg.split('');
      const requiredLetters = [0, 2, 3, 6];

      this.setState({
        vehicleReg: vehicleRegArray,
        requiredLetters,
        isLoading: false,
      });
    } catch (error) {
      console.error('Error fetching vehicle reg:', error);
      this.setState({
        isLoading: false,
        loadError: error.message || 'Failed to initialize security checks. Please check your network connection.',
      });
      toastr.error('Failed to initialize security checks. Please check your network connection.');
    }
  }

  verifyVehicleReg = async () => {
    try {
      const state = {
        ...this.state,
      };
      const vehicleRegVerified = await Claim
        .VerifyVehicleReg(this.props.CustAppId, state.vehicleReg.join(''));
      console.log('Verifying vehicle registration number.');
      if (vehicleRegVerified) {
        await Database.VerifyVehicleReg(vehicleRegVerified);
        const claimData = await Claim.FetchClaimData();
        await Database.WriteInitialData(claimData);
        if (window.location.href.includes('additionalinfo')) {
          window.location.href = `/additionalinfo?${this.props.CustAppId}`;
        } else {
          window.location.href = `/?${this.props.CustAppId}`;
        }
      } else {
        throw new Error('Incorrect vehicle registration number supplied.');
      }
    } catch (error) {
      console.error('Error verifying vehicle reg:', error);
      this.setState({ showHelp: true });
      toastr.error(error.message || 'Error verifying vehicle registration number. Please try again.');
    }
  };

  render() {
    const {
      isLoading, loadError, vehicleReg, requiredLetters, showHelp,
    } = this.state;
    if (isLoading) {
      return (
        <div id="verify-reg-form" className="col-xs-12">
          <div className="col-xs-12" id="logo-container">
            <img id="company-logo" alt="Autoboys" src={Logo} className="center-block" />
          </div>
          <div className="col-xs-12 text-center">
            <p>Loading...</p>
          </div>
        </div>
      );
    }

    if (loadError) {
      return (
        <div id="verify-reg-form" className="col-xs-12">
          <div className="col-xs-12" id="logo-container">
            <img id="company-logo" alt="Autoboys" src={Logo} className="center-block" />
          </div>
          <div className="col-xs-12 text-center">
            <div className="alert alert-danger">
              <h4>Unable to Load</h4>
              <p>{loadError}</p>
              <p>Please check your network connection or contact support.</p>
            </div>
          </div>
          <div
            className="col-xs-12 text-center"
            onClick={() => { Claim.PingContactUs(); document.location.href = 'tel:0106008888'; }}
            onKeyDown={() => { Claim.PingContactUs(); document.location.href = 'tel:0106008888'; }}
            role="button"
            tabIndex={0}
          >
            <img src={Call} className="get-help" alt="Get Help" />
            <br />
            Get Help
            <br />
            <b>0106008888</b>
          </div>
        </div>
      );
    }

    return (
      <div id="verify-reg-form" className="col-xs-12">
        <div className="col-xs-12" id="logo-container">
          <img id="company-logo" alt="Autoboys" src={Logo} className="center-block" />
        </div>
        <div className="col-xs-12">
          <p>
            Welcome to the Autoboys customer application.
            Please verify your vehicle registration number to start your claim.
          </p>
        </div>
        <div className="form-group col-xs-12">
          <label htmlFor="vehicle-reg">Vehicle Registration</label>
          <div id="vehicle-reg">
            {vehicleReg.map((item, index) => {
              const inputKey = `reg-input-${vehicleReg.join('')}-${index}`;
              if (requiredLetters.includes(index)) {
                return (
                  <input
                    key={inputKey}
                    type="text"
                    onChange={(e) => this.setState({ [`txt${index}`]: e.target.value.toUpperCase() })}
                    value={this.state[`txt${index}`] || ''}
                    className="form-control reg-verify"
                    maxLength="1"
                  />
                );
              }
              return (
                <input
                  key={inputKey}
                  type="text"
                  value={item}
                  readOnly
                  size="1"
                  className="form-control reg-verify"
                />
              );
            })}
          </div>
        </div>
        <div className="form-group col-xs-12">
          <button
            type="button"
            className="btn btn-success btn-lg col-xs-12"
            onClick={this.verifyVehicleReg}
          >
            Verify
          </button>
        </div>
        <div
          className={showHelp ? 'col-xs-12 text-center' : 'col-xs-12 text-center hidden'}
          onClick={() => { Claim.PingContactUs(); document.location.href = 'tel:0106008888'; }}
          onKeyDown={() => { Claim.PingContactUs(); document.location.href = 'tel:0106008888'; }}
          role="button"
          tabIndex={0}
        >
          <img src={Call} className="get-help" alt="Get Help" />
          <br />
          Get Help
          <br />
          <b>0106008888</b>
        </div>
      </div>
    );
  }
}

VerifyVehicleReg.propTypes = {
  CustAppId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  CustAppId: state.CustAppId,
});

export default connect(mapStateToProps)(VerifyVehicleReg);
